export default {
    data: function(){
        return {
            filters: [],
            filtersLoading: true
        }
    },
    methods: {
        actionHandler: function(data){
            this[data.method](data);
        },
        exportData: function(){
            const datatable = this.$refs.datatable;
            datatable.exportData();
        },
    },
    watch: {
        filters: function(){
            if (this.filters.length === this.numberOfFilters){
                this.filtersLoading = false;
            }
        }
    },
    computed: {
        searchValue() {
            const filters = this.$store.getters.filters;

            if (filters[this.resource] && filters[this.resource].search) {
                return filters[this.resource].search.value;
            } else {
                return '';
            }
        },
    }
}
